<template>
  <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners" class="msg-list-dialog">
    <div class="dialog-body">
      <div class="content">
        <div class="tree">
          <el-tree
            ref="tree"
            :data="templateList"
            :props="treeProps"
            node-key="id"
            :highlight-current="true"
            :expand-on-click-node="true"
            :default-expand-all="true"
            @node-click="handleNodeClick"
            :default-expanded-keys="expandedKeys"
          >
            <span v-if="data.id === tempalteData.id" class="tree-item" slot-scope="{ data }">
              <span class="line1">{{ data.name }}</span>
            </span>
            <span class="tree-item" v-else>
              <span class="line1">{{ data.name }}</span>
            </span>
          </el-tree>
        </div>
        <div class="msg-content">
          <div class="item-title">{{ $t('base_msg_list_dialog.xiao_xi_nei_rong') }}</div>
          <div class="msg-content" v-html="form.content"></div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  components: {},
  data() {
    return {
      treeProps: {
        children: 'children',
        label: 'name'
      },
      expandedKeys: ['1'],
      templateList: [],
      tempalteData: {},
      form: {
        title: '',
        content: '',
        subTitle: '',
        langCode: 'CN',
        templType: 'app'
      }
    };
  },
  mounted() {
    this.getTemplateTree();
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    // 获取消息推送模板树
    getTemplateTree: function (type) {
      this.$getJSON(apis.MsgTemplateGroupTree).then((res) => {
        this.templateList = res.data;
        this.$nextTick(() => {
          if (type === 'delete') {
            // 清空模板消息
            this.tempalteData.id = null;
            this.tempalteData.data = null;
          }
          if (this.tempalteData.id) {
            this.$refs.tree.setCurrentKey(this.tempalteData.id);
            if (this.tempalteData.data.groupLevel === '2') {
              // 获取当前选中的树节点判断要不要去获取右侧
              this.getMsgTemplate();
            }
          }
        });
      });
    },
    // 获取模板内容
    getMsgTemplate: function () {
      this.form.title = '';
      this.form.subTitle = '';
      this.form.content = '';
      // 只有平台  邮件 才是富文本  isRichText是1
      if (this.form.templType === 'site' || this.form.templType === 'email') {
        this.form.isRichText = 1;
      } else {
        this.form.isRichText = 0;
      }
      this.$getJSON(`${apis.MsgTemplateGet}/?templGroupId=${this.tempalteData.id}&templType=${this.form.templType}&langCode=${this.form.langCode}`).then((res) => {
        const data = res.data || {};
        this.form.title = data.title || '';
        this.form.subTitle = data.subTitle || '';
        this.form.content = data.content || '';
      });
    },
    // 选中树
    handleNodeClick: function (row) {
      this.expandedKeys = [row.id];
      // 当前选中的分组
      this.tempalteData = row;
      // 叶子才会获取模板内容
      // 更新右边数据
      this.getMsgTemplate();
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-list-dialog {
  .content {
    height: 450px;
    display: flex;

    .tree {
      width: 350px;
      overflow-y: auto;
    }
    .msg-content {
      flex: 1;
      padding: 0 15px;
    }
  }
}
</style>
